import * as R from 'ramda';
import { requestWithAuthorization } from './requestWithAuthorization';
import portalConfigure from '@/portal-configure';
import { ConversionApiClientInfo, ErrorInfo } from '@/types/type';

export const getConversionApiClientInfo = async (
  tenant: string,
  landscape: string
): Promise<ConversionApiClientInfo> => {
  const response = await requestWithAuthorization
    .get(
      `${portalConfigure.API.conversionApiClientInfo}/${tenant}/${landscape}`
    )
    .catch(error => {
      const status = R.path(['response', 'status'], error);
      const data = R.path(['response', 'data'], error);
      if (status !== 404) {
        if (data) {
          error.message = JSON.stringify(data);
        }
        throw error;
      }
    });
  const data = R.path(['data'], response);
  return data as ConversionApiClientInfo;
};

export const putConversionApiClientInfo = async (
  tenant: string,
  landscape: string,
  clientId: string,
  clientSecret: string
) => {
  await requestWithAuthorization
    .put(`${portalConfigure.API.conversionApiClientInfo}`, {
      tenant,
      landscape,
      clientId,
      clientSecret,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00005',
          title: 'Error in create Web API client info.',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });
};

export const deleteConversionApiClientInfo = async (
  tenant: string,
  landscape: string
) => {
  await requestWithAuthorization
    .delete(
      `${portalConfigure.API.conversionApiClientInfo}/${tenant}/${landscape}`
    )
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00006',
          title: 'Error in delete Web API client info.',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });
};
